module.exports = __webpack_public_path__ + "static/media/DSC09673.bd62eb66.jpg";